/**
 * Created by razial on 21.09.2026.
 */

cleverapps.overrideStyles(cleverapps.styles.LanternWindow, {
    flashingArrows: true,
    timer: {
        y: { align: "top", dy: -15 }
    },
    bonuses: {
        margin: 10,
        images: {
            moves: {
                scale: 1.0
            }
        },
        y: { align: "bottom", dy: 30 }
    },
    animation: {
        y: 80,
        scale: 0.8
    },
    text: {
        width: 750,
        height: 100
    }
});
